import { render } from "./funds.vue?vue&type=template&id=99fe6422&scoped=true"
import script from "./funds.vue?vue&type=script&lang=js"
export * from "./funds.vue?vue&type=script&lang=js"

import "./funds.vue?vue&type=style&index=0&id=99fe6422&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99fe6422"]])

export default __exports__